export default {
  created() {
    this.CERT_LANDOWNER = 1;
    this.CERT_LF_EMPLOY = 2;
    this.CERT_LF_FID = 3;

    this.certificationMethods = {
      [this.CERT_LANDOWNER]: 'The Landowner will use their FOResT account to certify this FON.',
      [this.CERT_LF_EMPLOY]: `I am a Licensed Forester in the regular employ of the Landowner and am
                            authorized by the landowner to certify this FON on their behalf
                            (Chapter 26, Section 3.A.1.).`,
      [this.CERT_LF_FID]: `I am a Licensed Forester with a fiduciary responsibility to the
                            landowner and am authorized by the landowner to certify this FON on
                            their behalf (12§8883-B.2.J).`,
    };
  },
};
